import { z } from 'zod'

export const genericOpinionSchema = z.object({
	opinion: z.string().min(4),
})
